import { render, staticRenderFns } from "./prdDashboard.vue?vue&type=template&id=09326ba6&scoped=true&"
import script from "./prdDashboard.vue?vue&type=script&lang=js&"
export * from "./prdDashboard.vue?vue&type=script&lang=js&"
import style0 from "./prdDashboard.vue?vue&type=style&index=0&id=09326ba6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09326ba6",
  null
  
)

export default component.exports